import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import SingleBlogView from "@/views/SingleBlogView.vue";
import SinglePageView from "@/views/SinglePageView.vue";
import SignupView from "@/views/SignupView.vue";
import SigninView from "@/views/SigninView.vue";
import DashboardView from "@/views/DashboardView.vue";
import SubscriptionsView from "@/views/SubscriptionsView.vue";
import DomainSelectionView from "@/views/DomainSelectionView.vue";
import DomainSelectedSuccessfullyView from "@/views/DomainSelectedSuccessfullyView.vue";
import ProfileView from "@/views/ProfileView.vue";
import InvoicesView from "@/views/InvoicesView.vue";
import TicketListView from "@/views/TicketListView.vue";
import TicketDetailsView from "@/views/TicketDetailsView.vue";
import ContactView from "@/views/ContactView.vue";
import ExternalPaymentView from "@/views/ExternalPaymentView.vue";
import PaymentSuccessView from "@/views/PaymentSuccessView.vue";
import { useAuthStore } from "@/stores/authStore";

const routes = [
  {
    path: "/auth/signup",
    name: "signup",
    meta: {
      layout: "auth",
      requiresAuth: false,
    },
    component: SignupView,
  },
  {
    path: "/auth/signin",
    name: "signin",
    meta: {
      layout: "auth",
      requiresAuth: false,
    },
    component: SigninView,
  },
  {
    path: "/auth/password-reset",
    name: "password-reset",
    meta: {
      layout: "auth",
      requiresAuth: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "password-reset" */ "../views/PasswordResetView.vue"
      ),
  },
  {
    path: "/auth/password-reset-confirm",
    name: "password-reset-confirm",
    meta: {
      layout: "auth",
      requiresAuth: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "password-reset-confirm" */ "../views/PasswordResetConfirmView.vue"
      ),
  },
  {
    path: "/user/dashboard",
    name: "dashboard",
    meta: {
      layout: "dashboard",
      requiresAuth: true,
    },
    component: DashboardView,
  },
  {
    path: "/external-payment/:orderId",
    name: "external-payment",
    meta: {
      layout: "dashboard",
      requiresAuth: false,
    },
    component: ExternalPaymentView,
  },
  {
    path: "/payment-success",
    name: "payment-success",
    meta: {
      layout: "dashboard",
      requiresAuth: false,
    },
    component: PaymentSuccessView,
  },
  {
    path: "/user/subscriptions",
    name: "subscriptions",
    meta: {
      layout: "dashboard",
      requiresAuth: true,
    },
    component: SubscriptionsView,
  },
  {
    path: "/user/domain-selection",
    name: "domain-selection",
    meta: {
      layout: "dashboard",
      requiresAuth: true,
    },
    component: DomainSelectionView,
  },
  {
    path: "/user/domain-selected-successfully/:subscriptionId",
    name: "domain-selected-successfully",
    meta: {
      layout: "dashboard",
      requiresAuth: true,
    },
    component: DomainSelectedSuccessfullyView,
  },
  {
    path: "/user/profile",
    name: "profile",
    meta: {
      layout: "dashboard",
      requiresAuth: true,
    },
    component: ProfileView,
  },
  {
    path: "/user/invoices",
    name: "invoices",
    meta: {
      layout: "dashboard",
      requiresAuth: true,
    },
    component: InvoicesView,
  },
  {
    path: "/user/tickets",
    name: "tickets",
    meta: {
      layout: "dashboard",
      requiresAuth: true,
    },
    component: TicketListView,
  },
  {
    path: "/user/tickets/:id",
    name: "ticket-details",
    meta: {
      layout: "dashboard",
      requiresAuth: true,
    },
    component: TicketDetailsView,
  },
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: {
      layout: "landing",
      requiresAuth: false,
    },
  },
  {
    path: "/about-us",
    name: "about",
    meta: {
      layout: "landing",
      requiresAuth: false,
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
  {
    path: "/contact-us",
    name: "contact",
    meta: {
      layout: "landing",
      requiresAuth: false,
    },
    component: ContactView,
  },
  {
    path: "/blogs",
    name: "blogs",
    meta: {
      layout: "landing",
      requiresAuth: false,
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/BlogsView.vue"),
  },
  {
    path: "/b/:slug",

    name: "blog",
    component: SingleBlogView,
    meta: {
      layout: "landing",
      requiresAuth: false,
    },
  },
  {
    path: "/p/:slug",

    name: "page",
    component: SinglePageView,
    meta: {
      layout: "landing",
      requiresAuth: false,
    },
  },

  // catch all 404
  {
    path: "/:catchAll(.*)",
    name: "404",
    meta: {
      layout: "landing",
      requiresAuth: false,
    },
    component: () =>
      import(/* webpackChunkName: "not-found" */ "../views/404View.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

router.beforeEach((to, from, next) => {
  const authStore = useAuthStore();

  //! Bura hakkinda bi rifat abi ile gorusulecek  token null degilse diye kontrol ama guvenli degil disardan 1 e set edilebilir
  if (to.meta.requiresAuth && authStore.token !== null) {
    next();
  } else if (to.meta.requiresAuth && authStore.token === null) {
    next({ name: "signin" });
  } else if (!to.meta.requiresAuth) {
    next();
  }
});

export default router;
